<div class="d-flex justify-content-center">
  <section class="w-100">
    <ion-searchbar
      [(ngModel)]="searchText"
      [placeholder]="placeholder"
      (ionChange)="onSearchChange($event)"
    >
    </ion-searchbar>
  </section>
</div>
